import execService from './../exec';

class Account {
  constructor() {
    this.apiPrefix = 'common.account';

    this.apis = {
      login: `${this.apiPrefix}.login`,
      logout: `${this.apiPrefix}.logout`,
      checkLoginState: `${this.apiPrefix}.checkLoginState`,
      getUserInfo: `${this.apiPrefix}.getUserInfo`
    };
  }

  /**
   * 弹出登录框
   * @param {Object} options 登录相关参数 eg: {source: 'xxxx', extraParams: {loginPage: 'QQ'}}
   * 已测试
   */
  login(options = {}) {
    execService.exec(this.apis.login, options);
  }

  /**
   * 登出
   * 已测试
   */
  logout() {
    execService.exec(this.apis.logout);
  }

  /**
   * 检查用户状态
   * 已测试
   */
  checkLoginState() {
    return execService.execPromise(this.apis.checkLoginState);
  }

  /**
   * 获取用户信息
   * 已测试
   * return {Promise}
   */
  getUserInfo() {
    return execService.execPromise(this.apis.getUserInfo);
  }
}

export default new Account();
